import React from "react";
import cl from "./Footer.module.css";
import { NavLink } from "react-router-dom";

const Footer = (props) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={cl.app_footer}>
      <div className={cl.app_footer_main}>
        <div className={cl.app_footer_links}>
          <h1>Go to:</h1>
          <NavLink className={cl.footer_link} to="">
            Home
          </NavLink>
          <NavLink className={cl.footer_link} to="/about">
            About
          </NavLink>
          {/* <NavLink className = { cl.footer_link } to='/news'>News</NavLink> */}
          <NavLink className={cl.footer_link} to="/products">
            Products
          </NavLink>
          <NavLink className={cl.footer_link} to="/contacts">
            Contacts
          </NavLink>
          <NavLink className={cl.footer_link} to="/policy">
            Privacy policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/terms">
            Terms of service
          </NavLink>
          <NavLink className={cl.footer_link} to="/refund-policy">
            Refund Policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/shipping-policy">
            Shipping Policy
          </NavLink>
          <NavLink className={cl.footer_link} to="/cookies-policy ">
            Cookies Policy
          </NavLink>
        </div>
        <div className={cl.app_footer_info}>
          <h2>Payment system:</h2>
          <img
            src="https://cdn.icon-icons.com/icons2/1186/PNG/512/1490135017-visa_82256.png"
            alt="Visa"
          />
          <img
            src="https://www.iconarchive.com/download/i76278/designbolts/credit-card-payment/Master-Card.ico"
            alt="Master Card"
          />
        </div>
        <div className={cl.app_footer_info}>
          <h2>WE WANT TO HEAR YOUR VOICE:</h2>
          <p>
            Our company was established in 2012 with only 3 employees. Over the
            years, perfectturn has more than 500,000 satisfied customers. It's
            important that we continue to deliver amazing products to our best
            customers, each of which includes customer service via phone, text
            and email. We look forward to growing with you!
          </p>
        </div>
      </div>
      <div className={cl.app_footer_bottom_line}>
        <p>
          Copyright {currentYear} {props.shopName}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
